// extracted by mini-css-extract-plugin
export default {"container":"NewGame_container__IPefu","betContainer":"NewGame_betContainer__pWY6B"};